<template>
  <div>
    <el-button
      v-if="this.activeName == '1'"
      class="button"
      type="primary"
      @click="add()"
      >新增</el-button
    >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="分类管理" name="1">
        <!-- 标题 -->
        <div class="title">
          <div>经穴分类管理</div>
          <div>
            <el-button
              type="primary"
              style="margin-top: 20px;"
              @click="editSort()"
              >排序管理</el-button
            >
            <el-button
              v-show="isSortShow"
              type="primary"
              style="margin-top: 20px;"
              @click="saveSortData()"
              >保存排序</el-button
            >
          </div>
        </div>
        <el-table
          :data="classMeridiansData"
          style="width: 100%; margin-bottom: 20px"
          v-show="isSortShow"
          ref="multipleTable"
          row-key="id"
          v-loading="loading"
          border
        >
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>
          <el-table-column prop="title" align="center" label="名称" width="150">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="classMeridiansData"
          v-show="!isSortShow"
          style="width: 100%; margin-bottom: 20px"
          v-loading="loading"
          border
        >
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>
          <el-table-column prop="title" align="center" label="名称" width="150">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="经穴管理" name="2">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <div class="search-left-top">
            <el-form-item label="穴名：">
              <el-input v-model="formInline.title"></el-input>
            </el-form-item>
            <el-form-item label="分类：">
              <el-select v-model="formInline.category_id">
                <el-option
                  v-for="item in jingxueClass"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <!-- 标题 -->
        <div class="title">
          <div>经穴列表</div>
          <el-button type="primary" @click="search()">查询</el-button>
        </div>
        <el-table :data="yianData" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center" width="100">
          </el-table-column>
          <el-table-column prop="title" label="穴名" align="center">
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="经脉分类"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row)">详情</el-button>
              <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="yian_totalPages > 1">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="yian_currentPage"
            :page-size="yian_page_size"
            :total="yian_pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 一级/二级分类编辑弹出框 -->
    <el-dialog
      :visible.sync="editMeridiansVisible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '1'"
    >
      <el-form :model="classForm" label-width="120px">
        <el-form-item label="分类名称：" prop="title">
          <el-input v-model="classForm.title"></el-input>
        </el-form-item>
      </el-form>
      <span
        v-if="is_add == false"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editMeridiansVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 医案管理编辑弹出框 -->
    <el-dialog
      :visible.sync="editJingxueVisible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '2'"
    >
      <el-form ref="ruleForm" :model="jingxueForm" label-width="180px">
        <el-form-item label="经穴ID：">
          <el-input type="text" v-model="jingxueForm.id"></el-input>
        </el-form-item>
        <el-form-item label="经穴名：">
          <el-input type="text" v-model="jingxueForm.title"></el-input>
        </el-form-item>
        <el-form-item label="百科名：">
          <el-input type="text" v-model="jingxueForm.bk_title"></el-input>
        </el-form-item>
        <el-form-item label="概述：">
          <el-input type="text" v-model="jingxueForm.introduce"></el-input>
        </el-form-item>
        <el-form-item label="定位：">
          <el-input type="text" v-model="jingxueForm.position"></el-input>
        </el-form-item>
        <el-form-item label="解刨：">
          <el-input type="text" v-model="jingxueForm.anatomy"></el-input>
        </el-form-item>
        <el-form-item label="主治：">
          <el-input type="text" v-model="jingxueForm.treat"></el-input>
        </el-form-item>
        <el-form-item label="配伍：">
          <el-input type="text" v-model="jingxueForm.pei"></el-input>
        </el-form-item>
        <el-form-item label="临床：">
          <el-input type="text" v-model="jingxueForm.clinical"></el-input>
        </el-form-item>
        <el-form-item label="别名：">
          <el-input type="text" v-model="jingxueForm.alias"></el-input>
        </el-form-item>
        <el-form-item label="穴义：">
          <el-input type="text" v-model="jingxueForm.xueyi"></el-input>
        </el-form-item>
        <el-form-item label="名解：">
          <el-input type="text" v-model="jingxueForm.explain"></el-input>
        </el-form-item>
        <el-form-item label="功能：">
          <el-input type="text" v-model="jingxueForm.effect"></el-input>
        </el-form-item>
        <el-form-item label="功能治法：">
          <el-input type="text" v-model="jingxueForm.action_zhi"></el-input>
        </el-form-item>
        <el-form-item label="附注：">
          <el-input type="text" v-model="jingxueForm.mark"></el-input>
        </el-form-item>
        <el-form-item label="类目：">
          <el-select v-model="jingxueForm.categories_id" class="handle-select">
            <el-option
              v-for="item in categoryClass"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经穴图片：">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="jingxueForm.full_img_path"
              :src="jingxueForm.full_img_path"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!jingxueForm.full_img_path && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="标签：">
          <div
            v-for="(item, i) in jingxueForm.labels"
            :key="i"
            style="margin-bottom: 10px;display: flex;align-items: center;"
          >
            <el-select v-model="item.type" class="handle-select">
              <el-option
                v-for="(child, index) in bqList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <el-input
              type="text"
              v-model="item.title"
              style="width:200px;margin-left: 10px;margin-right: 10px;"
            ></el-input>
            <el-button type="primary" @click="delBq(i)">删 除</el-button>
          </div>
          <el-button type="primary" @click="addBq">添 加</el-button>
        </el-form-item>
      </el-form>
      <span
        v-if="is_add == false"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editJingxueVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
import http2 from "../../../api/uploadApiConfig";
import Sortable from "sortablejs";
import md5 from "js-md5";
export default {
  data() {
    return {
      imageUrl: "",
      uploading: false,
      editMeridiansVisible: false,
      editJingxueVisible: false,
      editHotVisible: false,
      classificationDataLv2Visible: false,
      is_add: true,
      parent_id: "",
      class_id: "",
      p_id: "",
      classification_type: 1,
      jingxue_id: "",
      activeName: "1",
      loading: false,
      father_class: [{ label: "无", value: 0 }],
      // ----------------搜索----------------
      formInline: {},
      jingxueClass: [],
      price_type: [],
      isRecommend: [],
      //   一级分类
      classMeridiansData: [],
      //   二级分类
      classificationDataLv2: [],
      //   医案列表
      yianData: [],
      //   热门列表
      hotData: [],
      //   医案管理分页
      yian_currentPage: 1,
      yian_totalPages: 1,
      yian_page_size: 10,
      yian_pageTotal: 10,
      yian_page_index: 10,
      //   二级分类分页
      lv2_currentPage: 1,
      lv2_totalPages: 1,
      lv2_page_size: 10,
      lv2_pageTotal: 10,
      lv2_page_index: 10,
      classForm: {},
      jingxueForm: {},
      categoryClass: [],
      options1: [],
      categoryProps1: {
        label: "title", // 字段必须统一
        value: "id", // 字段必须统一
      },
      category_ids: "",
      // 标签
      labels: "",
      bqList: [
        {
          value: "1",
          label: "书名",
        },
        {
          value: "2",
          label: "书目",
        },
        {
          value: "3",
          label: "作者",
        },
        {
          value: "4",
          label: "科室",
        },
        {
          value: "5",
          label: "医生",
        },
        {
          value: "6",
          label: "出处",
        },
        {
          value: "7",
          label: "疾病",
        },
        {
          value: "9",
          label: "功效",
        },
        {
          value: "10",
          label: "经络",
        },
        {
          value: "11",
          label: "朝代",
        },
        {
          value: "12",
          label: "方剂名",
        },
        {
          value: "13",
          label: "中药名称",
        },
        {
          value: "14",
          label: "经穴名称",
        },
      ],
      hotForm: {},
      //   优先级
      priority: [
        { label: "1", value: 0 },
        { label: "2", value: 1 },
        { label: "3", value: 2 },
        { label: "4", value: 3 },
        { label: "5", value: 4 },
        { label: "6", value: 5 },
        { label: "7", value: 6 },
        { label: "8", value: 7 },
        { label: "9", value: 8 },
        { label: "10", value: 9 },
      ],
      f_price: 0,
      //   定价
      priceList: [
        {
          value: 0,
          label: "自定义",
        },
        {
          value: 1,
          label: "默认公式",
        },
      ],
      //   免费状态
      f_discount_type: 1,
      free_status: [
        {
          value: 0,
          label: "无优惠",
        },
        {
          value: 1,
          label: "免费",
        },
        {
          value: 2,
          label: "限时免费",
        },
        {
          value: 3,
          label: "折扣",
        },
        {
          value: 4,
          label: "限时折扣",
        },
      ],
      isSortShow: false,
      dataArr: [],
      ids: [],
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    // 排序管理
    editSort() {
      this.isSortShow = !this.isSortShow;
    },
    // 保存排序
    saveSortData() {
      this.ids = [];
      for (let i = 0; i < this.dataArr.length; i++) {
        this.ids.push(this.dataArr[i].id);
      }
      let params = {
        ids: this.ids.toString(),
      };
      http.put("/admin/zsk/sort/meridians/categories", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("保存成功");
          this.isSortShow = false;
          this.getDefault();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["multipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.dataArr.splice(evt.oldIndex, 1)[0];
          this.dataArr.splice(evt.newIndex, 0, tempIndex);
          console.log(this.dataArr, "dataArr");
        },
      });
    },
    addBq() {
      var newItem = { bq_name: "", leiMu: "" };
      this.jingxueForm.labels.push(newItem);
    },
    delBq(i) {
      this.jingxueForm.labels.splice(i, 1);
    },
    getDefault() {
      if (this.activeName == 1) {
        this.loading = true;
        http.get("/admin/zsk/meridians_categorys").then((res) => {
          if (res.data.status_code == 200) {
            this.categoryClass = res.data.data;
            this.classMeridiansData = res.data.data;
            this.dataArr = res.data.data;
            this.$nextTick(() => {
              this.initSortTable();
            });
            this.jingxueClass = res.data.data;
            this.loading = false;
          }
        });
      } else if (this.activeName == 2) {
        this.loading = true;
        let params = {
          page: this.yian_currentPage,
          yian_page_size: this.yian_page_size,
          title: this.formInline.title,
          category_id: this.formInline.category_id,
        };
        http
          .get("/admin/zsk/meridians_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              this.yianData = res.data.data.data;
              this.yian_currentPage = Number(res.data.data.current_page);
              this.yian_totalPages = res.data.data.last_page;
              this.yian_pageTotal = this.yian_totalPages * this.yian_page_size;
              this.loading = false;
            }
          });
        // http.get("/admin/zsk/meridians_categorys").then((res) => {
        //   if (res.data.status_code == 200) {
        //     this.jingxueClass = res.data.data;
        //   }
        // });
      }
    },
    getSflx(row) {
      if (row.discount_type == 0) {
        return "无优惠";
      } else if (row.discount_type == 1) {
        return "免费";
      } else if (row.discount_type == 2) {
        return (
          row.discount.begin_time + "~" + row.discount.end_time + "\n限时免费"
        );
      } else if (row.discount_type == 3) {
        return "折扣";
      } else if (row.discount_type == 4) {
        return (
          row.discount.begin_time + "~" + row.discount.end_time + "\n限时折扣"
        );
      }
    },
    // 搜索
    search() {
      if (this.activeName == 2) {
        this.getDefault();
      }
    },
    // 新增
    add() {
      if (this.activeName == "1") {
        this.classification_type = 1;
        this.classForm = {};
        this.is_edit = false;
        this.is_add = false;
        this.editMeridiansVisible = true;
      } else if (this.activeName == "2") {
        this.jingxueForm = {};
        this.editJingxueVisible = true;
        this.is_edit = false;
        this.is_add = false;
      }
    },
    // 提交
    saveEdit() {
      if (this.activeName == "1") {
        if (this.is_edit == true) {
          let params = {
            title: this.classForm.title,
          };
          http
            .put("/admin/zsk/meridians_category/" + this.classForm.id, params)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("修改成功");
                this.getDefault();
                this.editMeridiansVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          let params = {
            title: this.classForm.title,
          };
          http.post("/admin/zsk/meridian_category", params).then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("新增成功");
              this.getDefault();
              this.editMeridiansVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      } else if (this.activeName == "2") {
        if (this.is_edit == true) {
          let params = this.jingxueForm;
          if (params.full_img_path) {
            delete params.full_img_path;
          }
          params.img_path = this.imageUrl;
          // 标签处理
          let labels = this.jingxueForm.labels;
          let data = "";
          this.jingxueForm.labels = "";
          for (let i = 0; i < labels.length; i++) {
            data = labels[i].type + "_" + labels[i].title + ",";
            this.jingxueForm.labels += data;
          }
          this.jingxueForm.labels = this.jingxueForm.labels.substring(
            0,
            this.jingxueForm.labels.length - 1
          );
          http
            .put("/admin/zsk/meridians/" + this.jingxue_id, params)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.editJingxueVisible = false;
                this.getDefault();
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      }
    },
    // 图片上传
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        let fileNames = file.name.split("/")[0];
        var time = new Date().getTime();
        var filename = md5(time + fileNames) + "." + imgType;
        ossData.append("work_path", "mediawiki/acupuncture");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "mediawiki/acupuncture/" + filename;
            that.jingxueForm.img_path = URL.createObjectURL(file);
            that.jingxueForm.full_img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 详情
    detail(row) {
      this.is_add = true;
      this.editJingxueVisible = true;
      this.jingxue_id = row.id;
      this.getDetailInfo();
    },
    getDetailInfo() {
      let params = {
        title: this.classForm.title,
      };
      http
        .get("/admin/zsk/meridians/" + this.jingxue_id, params)
        .then((res) => {
          if (res.data.status_code == 200) {
            this.jingxueForm = res.data.data;
          }
        });
    },
    // 编辑
    edit(row) {
      if (this.activeName == "1") {
        this.is_edit = true;
        this.is_add = false;
        this.classForm = row;
        this.editMeridiansVisible = true;
      } else if (this.activeName == "2") {
        this.editJingxueVisible = true;
        this.is_add = false;
        this.is_edit = true;
        this.jingxue_id = row.id;
        this.getDetailInfo();
      }
    },
    // 删除
    del(row) {
      let that = this;
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/zsk/meridians_category/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已删除");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 选项卡
    handleClick(tab) {
      if (tab.index == 1) {
        this.getDefault();
      }
    },
    // 医案管理分页
    handlePageChange(val) {
      this.yian_currentPage = val;
      this.getDefault();
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
  height: 180px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
